<template>
  <form class="col-12 b-form b-dialog__form">
    <server-error class="mb-4" :error="error" />
    <CreatePaymentWidget @closeDialog="closeDialog" :paymentForm="payment" @savePayment="onSavePayment($event)"></CreatePaymentWidget>
  </form>
</template>

<script>
	import CreatePaymentWidget from "../../../widgets/CreatePaymentWidget";

	export default {
		components: {
			CreatePaymentWidget,
		},
		props: {
			payment: {
				default: null,
			}
		},
		data() {
			return {
				error: null,
			}
		},
		methods: {
			async onSavePayment(data) {
				try {
					this.error = null;
					if (!data.idInDB) {
						await this.$store.dispatch('createPayment', Object.assign({}, data));
					} else {
						await this.$store.dispatch('updatePayment', Object.assign({}, data));
					}

					this.closeDialog();
				} catch (e) {
					this.error = e;
				}
			},
			closeDialog() {
				this.$emit('closeDialog');
			}
		}
	}
</script>
